import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initContractRequestsShow');
    $('.cr-copy').on('click', function () {
      navigator.clipboard.writeText($(this).parent().find('.cr-value').text());
    });
  }
}